import { render, staticRenderFns } from "./buysim.vue?vue&type=template&id=56f72462&scoped=true&"
import script from "./buysim.vue?vue&type=script&lang=js&"
export * from "./buysim.vue?vue&type=script&lang=js&"
import style0 from "./buysim.vue?vue&type=style&index=0&id=56f72462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f72462",
  null
  
)

export default component.exports